import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["title", "href"]
const _hoisted_2 = { class: "gt-ellipsis tw-flex-1" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "gt-ellipsis" }
const _hoisted_5 = {
  key: 2,
  class: "sub-items"
}

import {SvgIcon} from '../svg.ts';
import {diffTreeStore} from '../modules/stores.ts';
import {ref} from 'vue';

type File = {
  Name: string;
  NameHash: string;
  Type: number;
  IsViewed: boolean;
}

type Item = {
  name: string;
  isFile: boolean;
  file?: File;
  children?: Item[];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'DiffFileTreeItem',
  props: {
    item: {}
  },
  setup(__props: any) {



const store = diffTreeStore();
const collapsed = ref(false);

function getIconForDiffType(pType) {
  const diffTypes = {
    1: {name: 'octicon-diff-added', classes: ['text', 'green']},
    2: {name: 'octicon-diff-modified', classes: ['text', 'yellow']},
    3: {name: 'octicon-diff-removed', classes: ['text', 'red']},
    4: {name: 'octicon-diff-renamed', classes: ['text', 'teal']},
    5: {name: 'octicon-diff-renamed', classes: ['text', 'green']}, // there is no octicon for copied, so renamed should be ok
  };
  return diffTypes[pType];
}

return (_ctx: any,_cache: any) => {
  const _component_DiffFileTreeItem = _resolveComponent("DiffFileTreeItem", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode("title instead of tooltip above as the tooltip needs too much work with the current methods, i.e. not being loaded or staying open for \"too long\""),
    (_ctx.item.isFile)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: _normalizeClass(["item-file", {'selected': _unref(store).selectedItem === '#diff-' + _ctx.item.file.NameHash, 'viewed': _ctx.item.file.IsViewed}]),
          title: _ctx.item.name,
          href: '#diff-' + _ctx.item.file.NameHash
        }, [
          _createCommentVNode(" file "),
          _createVNode(_unref(SvgIcon), { name: "octicon-file" }),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.item.name), 1 /* TEXT */),
          _createVNode(_unref(SvgIcon), {
            name: getIconForDiffType(_ctx.item.file.Type).name,
            class: _normalizeClass(getIconForDiffType(_ctx.item.file.Type).classes)
          }, null, 8 /* PROPS */, ["name", "class"])
        ], 10 /* CLASS, PROPS */, _hoisted_1))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "item-directory",
          title: _ctx.item.name,
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (collapsed.value = !collapsed.value), ["stop"]))
        }, [
          _createCommentVNode(" directory "),
          _createVNode(_unref(SvgIcon), {
            name: collapsed.value ? 'octicon-chevron-right' : 'octicon-chevron-down'
          }, null, 8 /* PROPS */, ["name"]),
          _createVNode(_unref(SvgIcon), {
            class: "text primary",
            name: collapsed.value ? 'octicon-file-directory-fill' : 'octicon-file-directory-open-fill'
          }, null, 8 /* PROPS */, ["name"]),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.item.name), 1 /* TEXT */)
        ], 8 /* PROPS */, _hoisted_3)),
    (_ctx.item.children?.length)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.children, (childItem) => {
            return (_openBlock(), _createBlock(_component_DiffFileTreeItem, {
              key: childItem.name,
              item: childItem
            }, null, 8 /* PROPS */, ["item"]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */)), [
          [_vShow, !collapsed.value]
        ])
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})